import React, { useState, useEffect, useRef } from "react";
import "./testimonials-section.m.css";
import { LeftArrowIcon } from "../left-arrow-icon";
import { RightArrowIcon } from "../right-arrow-icon";
import { QuoteIcon } from "./quote-icon";
import { SUBSCRIPTION_PAGE_STRINGS } from "../../../../constants";
import { SliderIndicators } from "../slider-indicators";

import { optimizeImageUrl } from "../utils";

const TestimonialsSection = ({ colors = {}, fetchUrl = "/pv-testimonial" }) => {
  const s = SUBSCRIPTION_PAGE_STRINGS.PV, [items, setItems] = useState([]), [activeIndex, setActiveIndex] = useState(0), scrollRef = useRef(null), sectionRef = useRef(null);
  useEffect(() => { fetch(fetchUrl).then(res => res.json()).then(d => setItems(d?.testimonial_section?.testimonials || d?.testimonials || d?.items || [])).catch(() => {}); }, []);
  useEffect(() => {
    if (!sectionRef.current) return;
    sectionRef.current.querySelectorAll("[data-arrow-border], [data-arrow-icon]").forEach(el => el.setAttribute("stroke", colors.palette2 || ""));
  }, [colors, items]);

  const hScroll = () => { if (scrollRef.current) setActiveIndex(Math.round((scrollRef.current.scrollLeft / (scrollRef.current.scrollWidth - scrollRef.current.clientWidth)) * 1) || 0); };
  
  useEffect(() => {
    if (items.length <= 1) return;
    const timer = setInterval(() => {
      if (scrollRef.current) {
        const c = scrollRef.current, maxScroll = c.scrollWidth - c.clientWidth;
        if (maxScroll > 0) {
          const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;
          let nextScroll = c.scrollLeft + (isMobile ? c.clientWidth : maxScroll);
          if (nextScroll > maxScroll + 10) nextScroll = 0;
          c.scrollTo({ left: nextScroll, behavior: "smooth" });
        }
      }
    }, 4000);
    return () => clearInterval(timer);
  }, [activeIndex, items.length]);

  const scroll = d => scrollRef.current?.scrollBy({ left: d === "left" ? -360 : 360, behavior: "smooth" });
  if (!items.length) return null;

  return (
    <section styleName="testimonials-section" ref={sectionRef}>
      <h2 styleName="heading" style={colors.text_color ? { color: colors.text_color } : {}}>{s.TESTIMONIALS_HEADING}</h2>
      <div styleName="carousel">
        <button styleName="arrow" onClick={() => scroll("left")} type="button"><LeftArrowIcon /></button>
        <div styleName="viewport">
          <div styleName="cards-container" ref={scrollRef} onScroll={hScroll}>
            {items.map((it, i) => (
              <article key={it.id || i} styleName="card" style={{ backgroundColor: colors.palette3, borderColor: colors.palette1 }}>
                <div styleName="quote-icon"><QuoteIcon color={colors.palette2} /></div>
                <div styleName="description" style={colors.text_color ? { color: colors.text_color } : {}}>{it.description || it.text || ""}</div>
                <div styleName="profile">
                  <div styleName="profile-image-wrap"><img src={optimizeImageUrl(it.profile_image || it.image, 80)} alt="" styleName="profile-image" /></div>
                  <div styleName="profile-details">
                    <div styleName="name" style={colors.text_color ? { color: colors.text_color } : {}}>{it.name || ""}</div>
                    <div styleName="occupation" style={colors.text_color ? { color: colors.text_color } : {}}>{it.occupation || it.designation || ""}</div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
        <button styleName="arrow" onClick={() => scroll("right")} type="button"><RightArrowIcon /></button>
      </div>
      {items.length > 1 && <SliderIndicators count={2} activeIndex={activeIndex} accentColor={colors.palette2} onClick={(i) => {
        if (scrollRef.current) {
          const maxScroll = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
          scrollRef.current.scrollTo({ left: i * maxScroll, behavior: "smooth" });
        }
      }} />}
    </section>
  );
};
export { TestimonialsSection };
